/**
 * Cliente API de pagos para el frontend-portal (Sprint 13 S13-04,
 * migrado desde frontend-superadmin tras la doctrina Portal vs
 * Superadmin del 2026-05-13).
 *
 * Consume `GET /pagos/` con filtros (S12-02) + endpoint multi-concepto
 * `POST /pagos/{id}/clasificar` (S11-V2-10) + sugerencia de
 * auto-distribucion (S7-06).
 */
import { apiFetch } from './client';
import type {
  ClasificarPagoInput,
  ClasificarPagoResponse,
  ListPagosFiltros,
  PagoManualInput,
  PagoRead,
  SugerenciaDistribucionRead,
} from './types';

export function listPagos(filtros: ListPagosFiltros = {}): Promise<PagoRead[]> {
  const params = new URLSearchParams();
  if (filtros.estado) params.set('estado', filtros.estado);
  if (filtros.lote_id) params.set('lote_id', filtros.lote_id);
  if (filtros.banco) params.set('banco', filtros.banco);
  if (filtros.search) params.set('search', filtros.search);
  const qs = params.toString();
  return apiFetch<PagoRead[]>(`/pagos/${qs ? `?${qs}` : ''}`);
}

export interface AutoRecientesCount {
  count: number;
  dias: number;
}

/** Conteo de pagos aprobados automáticamente (auto-distribución FIFO) en los
 * últimos `dias`. Alimenta el aviso al tesorero en la pantalla Pagos. */
export function getPagosAutoRecientesCount(
  dias = 7,
): Promise<AutoRecientesCount> {
  return apiFetch<AutoRecientesCount>(
    `/pagos/auto-recientes-count?dias=${dias}`,
  );
}

export function getSugerenciaDistribucion(
  pagoId: string,
): Promise<SugerenciaDistribucionRead> {
  return apiFetch<SugerenciaDistribucionRead>(
    `/pagos/${pagoId}/sugerencia-distribucion`,
  );
}

export function clasificarPago(
  pagoId: string,
  data: ClasificarPagoInput,
): Promise<ClasificarPagoResponse> {
  return apiFetch<ClasificarPagoResponse>(`/pagos/${pagoId}/clasificar`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/** Registra un pago manualmente (Sprint 21 S21-B1): para cuando el aviso del
 * banco no llegó por correo. Entra en `por_distribuir`; luego se clasifica a
 * la casa/cuota con el flujo existente. */
export function registrarPagoManual(data: PagoManualInput): Promise<PagoRead> {
  return apiFetch<PagoRead>('/pagos/manual', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function revertirAprobacionPago(pagoId: string): Promise<PagoRead> {
  return apiFetch<PagoRead>(`/pagos/${pagoId}/revertir-aprobacion`, {
    method: 'POST',
  });
}
